var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as Yup from "yup";
let lastMobileNumber = null;
let lastCheck = null;
const checkMobileNumber = (mobileNumber) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield fetch("/api/webshop/form-validation/mobile", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ mobile: mobileNumber }),
        });
        const data = yield response.json();
        return data.isValid;
    }
    catch (_a) {
        // Don't keep a failed check, so the next validation asks again.
        if (lastMobileNumber === mobileNumber) {
            lastCheck = null;
        }
        return new Yup.ValidationError("Error validating mobile number");
    }
});
export const validateMobileNumberServerSide = (mobileNumber) => {
    // Avoid a few server calls, do numbers shorter than 5 chars?
    if (mobileNumber.length < 5) {
        return Promise.resolve(false);
    }
    // Share the check while it is in flight too: passes on separate requests
    // finish out of order, and Formik keeps the errors of the last to finish.
    if (lastCheck === null || lastMobileNumber !== mobileNumber) {
        lastMobileNumber = mobileNumber;
        lastCheck = checkMobileNumber(mobileNumber);
    }
    return lastCheck;
};
